import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Upload, Form, Button, Input, Typography, Modal, Space, Row, Col, Table, Icon, Avatar, InputNumber, Spin, Select, Popconfirm } from 'antd'
import moment from 'moment'
import { alertMessage } from '../../../../utils/message'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'
import Container from '../../../../components/user/Container'
import ModalshowAllImage from '../../../../components/user/ModalshowAllImage/update'
import { checkStatusSessionHistory, checkRequestTypeSessionHistory, TextMessagesDetailHistory } from '../../../../utils/fund'
import {
    BrowserRouter as Router,
    Link,
    Route
} from 'react-router-dom'
import InputMask from "react-input-mask";
import { Queries, Mutations } from '../../../../graphql'

const { Text, Title } = Typography
const { TextArea } = Input;
const formItemLayout = {
	// labelCol: {
	//   xs: { span: 24 },
	//   sm: { span: 9 },
	// },
	// wrapperCol: {
	//   xs: { span: 24 },
	//   sm: { span:15 },
	// },
  };
const { Option } = Select;

const DOCUMENT_TYPE = [
    { label: 'ใบกองทุนสำรองเลี้ยงชีพ', value: 'ใบกองทุนสำรองเลี้ยงชีพ' },
    { label: 'อื่น ๆ', value: 'อื่น ๆ' },
]

class benefitsPerson extends Component {
	state = {
		dataTable:[],
        columns:[
            {
                title: 'คนที่',
                dataIndex: 'listNo',
				align:'center',
                vertical:'top',
                width:60,
                // render: (item, record, index) => item
                render: (item, record, index) => index+1
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>ชื่อ - นามสกุล <span class="color-red">*</span></span>
                },
                dataIndex: 'benefitsName',
				align:'center',
                vertical:'top',
                render: (item, record, index) => {
                    return <>
                                <Form.Item label={""} className="mb-0">
                                    { this.props.form.getFieldDecorator("benefitsName"+index, {
                                        initialValue: item,
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณาระบุ ชื่อ - นามสกุล',
                                        }],
                                    })(
                                        <Input 
                                            disabled={ this.state.statusInput }
                                            // defaultValue={item} 
                                            onBlur={ (e) => this.onChangeValueForm(index, e, 'benefitsName') }
                                        />
                                    )}
                                </Form.Item>
                            </>
                }
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>ความสัมพันธ์ <span class="color-red">*</span></span>
                },
                dataIndex: 'relationShip',
				align:'center',
                vertical:'top',
                width:140,
                render: (item, record, index) => {
                    return <>
                                <Form.Item label={""} className="mb-0">
                                    { this.props.form.getFieldDecorator("relationShip"+index, {
                                        initialValue: item ? item : [],
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณาระบุ ความสัมพันธ์',
                                        }],
                                    })(
                                        <Select 
                                        className="w-100"
                                        disabled={ this.state.statusInput }
                                        onBlur={ (e) => this.onChangeValueForm(index, e, 'relationShip') }
                                     >
                                        {
                                            this.state.dropdownRelationShipLabel.map((valuesLabel, keys)=>{
                                                return <Option value={valuesLabel}>{ valuesLabel }</Option>
                                            })
                                        }
                                    </Select>
                                    )}
                                </Form.Item>
                            </>
                }
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>เลขที่บัตรประชาชน <span class="color-red">*</span></span>
                },
                dataIndex: 'benefitsIdCard',
				align:'center',
                vertical:'top',
                width:175,
                render: (item, record, index) => {
                    return <>
                                <Form.Item label={""} className="mb-0">
                                    { this.props.form.getFieldDecorator("benefitsIdCard"+index, {
                                        initialValue: item,
                                        rules:  [
                                            { 
                                                required: true, 
                                                message: 'กรุณาระบุ เลขที่บัตรประชาชน',
                                            },
                                            { 
                                                // min: this.state.statusInput ? 13 : 13,
                                                min: 13,
                                                message: "เลขที่บัตรประชาชนต้องมีจำนวน 13 ตัวอักษร" 
                                            },
                                        ],
                                    })(
                                        <InputMask 
                                            disabled={ this.state.statusInput }
                                            mask="9-9999-99999-99-9" 
                                            maskChar="" 
                                            className="input-mask-idcard"
                                            onBlur={ (e) => this.onChangeValueForm(index, e, 'benefitsIdCard') }
                                        />
                                    )}
                                </Form.Item>
                            </>
                }
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>เปอร์เซ็นต์<br></br>ที่ได้รับ <span class="color-red">*</span></span>
                },
                dataIndex: 'benefitsRate',
				align:'center',
                vertical:'top',
                width:100,
                render: (item, record, index) => {
                    return <>
                            <Form.Item label={""} className="mb-0">
                                { this.props.form.getFieldDecorator("benefitsRate"+index, {
                                    initialValue: item,
                                    rules:  [{ 
                                        required: true, 
                                        message: 'กรุณาระบุ เปอร์เซ็นต์ที่ได้รับ',
                                    }],
                                })(
                                    <InputNumber 
                                        disabled={ this.state.statusInput }
                                        step={1000.01}
                                        // disabled={ record.wdSlipId ? checkDisbledInput(this.state.statusCanEdit, "totalPrice") ? true : false : false }
                                        formatter={item => `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        min={0.00}
                                        max={100}
                                        parser={item => item.replace(/\$\s?|(,*)/g, '')}
                                        onBlur={ (e) => this.onChangeValueForm(index, e, 'benefitsRate') }
                                        className="input-number"
                                    />
                                )}
                            </Form.Item>
                        </>
                }
            },
            {
                title: ()=>{
                    // return <span>ที่อยู่ <span class="color-red">*</span></span>
                    return <span>ที่อยู่ </span>
                },
                dataIndex: 'address',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return (
                        <>
							<Form.Item label={""} className="mb-0">
                                { this.props.form.getFieldDecorator("address"+index, {
                                    initialValue: item,
                                    // getValueFromEvent: value =>{
                                    //     return value && value !== '0' && value !== '-' ? value : ''
                                    // },
                                    rules:  [{ 
                                        required: false, 
                                        message: 'กรุณาระบุ ที่อยู่',
                                    }],
                                })(
                                    <TextArea 
                                        disabled={ this.state.statusInput }
                                        className="mt-1"
                                        rows={1}
                                        // defaultValue={item} 
                                        onBlur={ (e) => this.onChangeValueForm(index, e, 'address') }
                                    />
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: 'จัดการ',
                dataIndex: '7',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return  this.showInputBtn(record, index)
                }
            },
        ],
        loadTable: true,
        nameImage: null,
        showDataPreLoads: false,
        dataTalbeUploadsDocument: [
            {
                documentType: '',
                statusFile: false,
                description: '',
				file:[],
            }
        ],
        columnsDocument: [
            {
                title: 'ประเภทเอกสารแนบ',
                dataIndex: 'documentType',
				align:'center',
                vertical:'top',
                width:250,
                render: (item, record, index) => {
                    return(
                        <>
                            <Form.Item label={""}>
                                { this.props.form.getFieldDecorator("documentType"+index, {
                                    initialValue: item ? item : [],
                                    rules:  [{ 
                                        // required: record.description ? true : false,
                                        required: false,
                                        message: 'กรุณาเลือกประเภทเอกสาร',
                                    }],
                                })(
                                    <Select 
                                        disabled={ this.state.statusInput }
                                        style={{ width: "100%" }}
                                        onChange={ (e) => this.onChangeValueFormDocument(index, e, 'documentType') }
                                        showSearch
                                        placeholder="กรุณาเลือก"
                                        optionFilterProp="children"
                                        // disabled={ this.checkDisbledInputDocument(record) }
                                        // disabled={true}
                                    >
                                        {
                                            DOCUMENT_TYPE.map((valuesLabel, keys)=>{
                                                return <Option value={valuesLabel.value}>{ valuesLabel.label }</Option>
                                            })
                                        }
                                    </Select>
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: 'รายละเอียดเพิ่มเติม',
                dataIndex: 'description',
                vertical:'top',
				align:'center',
                width:300,
                render: (item, record, index) => {
                    return(
                        <>
                            <Form.Item label={""}>
                                { this.props.form.getFieldDecorator("description"+index, {
                                    initialValue: item ? item : [],
                                    rules:  [{ 
                                        required: record.statusFile ? true : false, 
                                        // require: true,
                                        message: 'กรุณากรอกรายละเอียด',
                                    }],
                                })(
                                    <Input 
                                        disabled={ this.state.statusInput }
                                        // defaultValue={item} 
                                        // disabled={ this.checkDisbledInputDocument(record) }
                                        // disabled={true}
                                        onBlur={ (e) => this.onChangeValueFormDocument(index, e, 'description') }
                                    />
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: 'เอกสารแนบ',
                dataIndex: '7',
                vertical:'top',
                width:200,
				align:'center',
                render: (item, record, index) => {
                    return (
                        <>
                            { this.inputFormUploadsDocument(index) }
                            { this.showMoreFileUploads(index, 'Doc') }
                        </>
                    )
                }
            },
            {
                title: 'จัดการ',
                dataIndex: '7',
                width:50,
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return this.showDetailBtnInputDocument(record, index)
                }
            },
        ],
        ModalshowAllImageVisible: false,
        ModalshowAllImageTitle:null,
        ModalshowAllImageData:[],
        ModalshowAllImageArrayId:null,
        ModalshowAllImageDatabase: false,
        providentFundRateId: null,
        deletedFundDocumentId: [],
        deletedFundBenefitPersonId: [],
        fundRequestId: null,
        statusInput: null,
        statusFormBtn: null,
        statusCanEdit: 'no',
        deletedFileId: [],
        detailForm: null
	}

    onChangeValueFormDocument = async (arrayId, values, name) =>{
        const { dataTalbeUploadsDocument } = this.state
        let dataSourceitems = [...this.state.dataTalbeUploadsDocument];
        let item = {...dataSourceitems[arrayId]};

        if(name == 'description'){
            item.description = values.target.value
        }else if(name == 'documentType'){
            item.documentType = values
            item.statusFile = values ? true : false
        }

        dataSourceitems[arrayId] = item;

        // console.log('dataSourceitems',dataSourceitems)

        await this.setState({
            dataTalbeUploadsDocument:dataSourceitems
        },async () => {
            // await this.setSummary()
            // this.setSummarySlipWithdraw()
			// this.cllBackSetValueContactNumber()
        })
    }

    deletedFundDocumentId = async (fundDocumentId, arrayId) =>{
        const { deletedFundDocumentId } = this.state

        deletedFundDocumentId.push(fundDocumentId)

        await this.setState({
            deletedFundDocumentId
        })

        await this.destroyArrayDataUploadsDocument(arrayId)
    }

    showDetailBtnInputDocument = (record, arrayId) =>{
        const { dataTalbeUploadsDocument, statusInput } = this.state
        return(
            <>
                 {
                            statusInput ?
                                <Avatar 
                                    disabled={true}
                                    shape="square"  
                                    icon={<Icon type="delete" />} 
                                    className="mr-1 mb-1 mt-1 bg-red"  
                                    style={{ cursor: 'not-allowed' }}
                                />
                            : 
                                <>
                                    {
                                        record.fundDocumentId ?
                                            <Popconfirm
                                                placement="topRight"
                                                title={"คุณต้องการที่จะลบไฟล์"}
                                                onConfirm= { () => this.deletedFundDocumentId(dataTalbeUploadsDocument[arrayId].fundDocumentId, arrayId) }
                                                okText="ตกลง"
                                                cancelText="ยกเลิก"
                                            >
                                                <Avatar 
                                                    shape="square"  
                                                    icon={<Icon type="delete" />} 
                                                    className="mr-1 mb-1 mt-1 bg-red"  
                                                    style={{ cursor: 'pointer', background:"red" }}
                                                />
                                            </Popconfirm>
                                            :  
                                                <Popconfirm
                                                    placement="topRight"
                                                    title={"คุณต้องการที่จะลบไฟล์"}
                                                    onConfirm= { () => this.destroyArrayDataUploadsDocument(arrayId) }
                                                    okText="ตกลง"
                                                    cancelText="ยกเลิก"
                                                >
                                                    <Avatar 
                                                        shape="square"  
                                                        icon={<Icon type="delete" />} 
                                                        className="mr-1 mb-1 mt-1 bg-red"  
                                                        style={{ cursor: 'pointer', background:"red" }}
                                                    />
                                                </Popconfirm>
                                        }
                                </>
                }
            </>
        )
    }

    destroyArrayDataUploadsDocument =  async (arrayId) =>{
        const { dataTalbeUploadsDocument } = this.state
        var arrayDataSource = [...this.state.dataTalbeUploadsDocument];
		arrayDataSource.splice(arrayId, 1);

		await this.setState({
			dataTalbeUploadsDocument:arrayDataSource,
            // dataTalbeLength: lengthData
		},async() => {
            let lengthData = arrayDataSource.length;
            await this.setState({
                dataTalbeLengthDocument: lengthData
            })

            arrayDataSource.map(async (valuesTable, keysTable) =>{
                let documentType = `documentType${keysTable}`
                let description = `description${keysTable}`
                // "documentType"+index
                
                await this.props.form.setFieldsValue({
                    [documentType]: valuesTable.documentType ? valuesTable.documentType : [],
                    [description]: valuesTable.description ? valuesTable.description : [],
                })
            })
			// this.cllBackSetValueContactNumber()
		})
    }

    destroyArrayDataImages =  async (arrayId, arraySpliceFileName, arrayFileId) =>{
        const { dataTalbeUploads, ModalTypeUpload, deletedFileId } = this.state
        let indexKey = null

        if(ModalTypeUpload == 'Doc'){
            var arrayDataSource = [...this.state.dataTalbeUploadsDocument];
            arrayDataSource[arrayId].file.map(( values, keys ) =>{
                if(arraySpliceFileName){
                    if(values.name == arraySpliceFileName){
                        indexKey = keys
                    }
                }else{
                    if(values.idFile == arrayFileId){
                        indexKey = keys
                        deletedFileId.push(arrayFileId)
                    }
                }
            })
            
            arrayDataSource[arrayId].file.splice(indexKey, 1);

            await this.setState({
                dataTalbeUploadsDocument: arrayDataSource
            },async() => {
                if(arrayDataSource[arrayId].file.length == 0) {
                    await this.setState({
                        ModalshowAllImageVisible: false
                    })
                }
            })
        }
    }

    inputFormUploadsDocument = (arrayId) =>{
        const { match } = this.props
        const { dataTalbeUploadsDocument, statusInput } = this.state
        return(
            <>
                {
                    !statusInput ?
                        <>
                            <label for={"input-fileDocument-"+arrayId} class="custom-file-upload">
                                <p className="py-2 px-4" align={"center"} style={{ backgroundColor:"#8d0e14", color:"#fff" }}>
                                    {/* อัปโหลด */}
                                    อัปโหลด +
                                </p>
                                <p style={{ fontSize:"12px" }} className="my-2">แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf</p>
                            </label>
                            <input
                                id={"input-fileDocument-"+arrayId}
                                className="input-file"
                                multiple
                                // name={uploadName}
                                type="file"
                                // accept="file_extension"
                                accept="image/png, image/jpeg, application/pdf"
                                // rules={ true }
                                onChange={e => this.handleAddDocument(e.target.files,arrayId)}
                                // onChange={e => console.log(e.target.files)}
                            />
                        </>
                    :
                        ''
                }
            </>
        )
    }

    handleAddDocument = async (images, arrayId ) => {
        const { dataTalbeUploadsDocument, reqAttachDayStatus } = this.state
        if(images){
            let dataSourceitems = [...this.state.dataTalbeUploadsDocument];
            let item = {...dataTalbeUploadsDocument[arrayId]};
            let checkImageType = false
            let arrayUploadsImage = [...images]
            const acceptedImageTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            // console.log('imassssges',...images)

            arrayUploadsImage.map((values, keys) => {
                if(!acceptedImageTypes.includes(values.type)){
                    checkImageType = true
                }
            })

            if(checkImageType){
                alertMessage("error","กรุณาอัปโหลดไฟล์นามสกุล  .jpg, .png หรือ .pdf")
            }else{
                 item.file.push(...images)
                item = {
                    documentType: item.documentType,
                    statusFile: item.documentType ? true : false,
                    description: item.description,
                    file: item.file,
                    fundDocumentId: item.fundDocumentId ? item.fundDocumentId : null
                }
                dataSourceitems[arrayId] = item;

                await this.setState(({
                    dataTalbeUploadsDocument: dataSourceitems,
                }), () => {
                    document.getElementById('input-fileDocument-'+arrayId).value = [];
                    // this.cllBackSetValueOrganizatuions()
                })
            }
           
        }
	}

    showMoreFileUploads = (arrayId, uploadFile) =>{
        const { dataTalbeUploads, dataTalbeUploadsDocument } = this.state
        let fileName = null
        let fileNameShow = null
        // console.log('dataTalbeUploadsDocument',dataTalbeUploadsDocument)
        // if(dataTalbeUploadsDocument[arrayId].fundDocumentId){
        //     return <>
        //                 {
        //                     dataTalbeUploadsDocument[arrayId].fileData.length !== 0 &&
        //                         <p 
        //                             onClick={ () => { this.ModalshowAllImageShow(dataTalbeUploadsDocument[arrayId].fileData, 'ไฟล์อัปโหลดเอกสารแนบอื่นๆ', arrayId, true, uploadFile) }} 
        //                             style={{ cursor:"pointer" }}
        //                             className="btn-show-fileuploads"
        //                         >
        //                             ดูไฟล์อัปโหลด
        //                         </p>
        //                     ||
        //                         ''
        //                 }
        //             </>
        // }else if(dataTalbeUploadsDocument[arrayId].file.length !== 0){
        if(dataTalbeUploadsDocument[arrayId].file.length !== 0){
            return  <>
                        <p 
                            onClick={ () => { this.ModalshowAllImageShow(dataTalbeUploadsDocument[arrayId].file, 'ไฟล์อัปโหลดเอกสารแนบ', arrayId, false, uploadFile) }} 
                            style={{ cursor:"pointer" }}
                            className="btn-show-fileuploads"
                        >
                            ดูไฟล์อัปโหลด
                        </p>
                    </>
        }else{
            return <span id={"showTextUplodasDoc"+arrayId}>กรุณาแนบเอกสารอื่นๆ อย่างน้อย 1 ฉบับ</span>
        }
    }

    ModalshowAllImageShow = async (data, title, arrayId, imageDatabase, modalTypeUpload)=>{
        // console.log('datdataa', data)
        await this.setState({
            ModalshowAllImageVisible: true,
            ModalshowAllImageTitle: title,
            ModalshowAllImageData: data,
            ModalshowAllImageArrayId: arrayId,
            ModalshowAllImageDatabase: imageDatabase,
            ModalTypeUpload : modalTypeUpload
        })
    }

    ModalshowAllImageHide = async () =>{
        await this.setState({
            ModalshowAllImageVisible: false,
            ModalshowAllImageTitle: null,
            ModalshowAllImageData: [],
            ModalshowAllImageArrayId: null,
            ModalshowAllImageDatabase: false
        })
    }

    onChangeValueForm = async (arrayId, values, name) =>{
        const { dataTable, providentFundRateId } = this.state
        let dataSourceitems = [...this.state.dataTable];
        let item = {...dataSourceitems[arrayId]};

        console.log('values',values)
        if(name == 'benefitsName'){
            item.benefitsName = values.target.value
        }else if(name == 'benefitsIdCard'){
            console.log('valuesxsxs', values.target.value)
            item.benefitsIdCard = values.target.value
        }else if(name == 'benefitsRate'){
            item.benefitsRate = parseFloat(values.target.value)
        }else if(name == 'address'){
            item.address = values.target.value
        }else if(name == 'relationShip'){
            item.relationShip = values
        }
        item.providentFundRateId = providentFundRateId
        dataSourceitems[arrayId] = item;

        await this.setState({
            dataTable:dataSourceitems
        },async () => {
            // await this.setSummary()
            // await this.setSummarySlipWithdraw()
            // await this.onChangeValueTotalCurrentWithdraw()
			// this.cllBackSetValueContactNumber()
        })
    }

    deletedFundBenefitPersonId = async (fundBenefitPersonId, arrayId) =>{
        const { deletedFundBenefitPersonId } = this.state

        deletedFundBenefitPersonId.push(fundBenefitPersonId)

        await this.setState({
            deletedFundBenefitPersonId
        })

        await this.destroyArrayData(arrayId)
    }

    showInputBtn = (record, arrayId) =>{
        const { dataTable, statusInput } = this.state
        return  (
                    <>
                        {
                            statusInput ?
                                <Avatar 
                                    disabled={true}
                                    shape="square"  
                                    icon={<Icon type="delete" />} 
                                    className="mr-1 mb-1 mt-1 bg-red"  
                                    style={{ cursor: 'not-allowed' }}
                                />
                            :
                                <>
                                    {
                                        dataTable.length > 1 ? 
                                            <>
                                                {
                                                    record.fundBenefitPersonId ? 
                                                        <Popconfirm
                                                            placement="topRight"
                                                            title={"คุณต้องการที่จะลบผู้รับผลประโยชน์"}
                                                            onConfirm={ () => this.deletedFundBenefitPersonId(record.fundBenefitPersonId, arrayId) }
                                                            okText="ตกลง"
                                                            cancelText="ยกเลิก"
                                                        >
                                                            <Avatar 
                                                                shape="square"
                                                                icon={<Icon type="delete" />} 
                                                                className="mr-1 mb-1 mt-1 bg-red"  
                                                                style={{ cursor: 'pointer', background:"red" }}
                                                            />
                                                        </Popconfirm>
                                                    :
                                                        <Popconfirm
                                                            placement="topRight"
                                                            title={"คุณต้องการที่จะลบผู้รับผลประโยชน์"}
                                                            onConfirm={ () => this.destroyArrayData(arrayId) }
                                                            okText="ตกลง"
                                                            cancelText="ยกเลิก"
                                                        >
                                                            <Avatar 
                                                                shape="square"  
                                                                icon={<Icon type="delete" />} 
                                                                className="mr-1 mb-1 mt-1 bg-red"  
                                                                style={{ cursor: 'pointer', background:"red" }}
                                                            />
                                                        </Popconfirm>
                                                }
                                            </>
                                        :
                                        <>
                                            {
                                                record.fundBenefitPersonId ?
                                                    <Avatar 
                                                        disabled={true}
                                                        shape="square"  
                                                        icon={<Icon type="delete" />} 
                                                        className="mr-1 mb-1 mt-1 bg-red"  
                                                        style={{ cursor: 'not-allowed' }}
                                                    />
                                                :
                                                    <Avatar 
                                                        disabled={true}
                                                        shape="square"  
                                                        icon={<Icon type="delete" />} 
                                                        className="mr-1 mb-1 mt-1 bg-red"  
                                                        style={{ cursor: 'not-allowed' }}
                                                    />
                                            }
                                        </>
                                    }
                                </>
                        }
                        
                    </>
                )
    }

    destroyArrayData =  async (arrayId) =>{
        const { dataTable } = this.state
        
        var arrayDataSource = [...this.state.dataTable];
		arrayDataSource.splice(arrayId, 1);

		await this.setState({
			dataTable:arrayDataSource,
            // dataTalbeLength: lengthData
		},async() => {
            // await this.setRowTableSammary()

            arrayDataSource.map(async (valuesTable, keysTable) =>{
                let listNo = `listNo${keysTable}`
                let benefitsName = `benefitsName${keysTable}`
                let benefitsIdCard = `benefitsIdCard${keysTable}`
                let benefitsRate = `benefitsRate${keysTable}`
                let address = `address${keysTable}`
                let relationShip = `relationShip${keysTable}`

                console.log('valuesTable.benefitsIdCard',valuesTable.benefitsIdCard)
                await this.props.form.setFieldsValue({
                    [listNo]: valuesTable.listNo,
                    [benefitsName]: valuesTable.benefitsName,
                    [benefitsIdCard]: valuesTable.benefitsIdCard ? valuesTable.benefitsIdCard : '',
                    [benefitsRate]: valuesTable.benefitsRate ? valuesTable.benefitsRate : '',
                    [address]: valuesTable.address,
                    [relationShip]: valuesTable.relationShip
                });
            })
		})
    }

    handleAddImages = async (images ) => {
        if(images){
            let imagesData = images

            console.log('images', imagesData[0].name)

            await this.setState({
                nameImage: imagesData[0].name,
                fileData: imagesData[0]
            })
        }
	}

    showDataInput = async () =>{
        const { dataTable, reqAttachDayStatus, providentFundRateId } = this.state
        const rows = {
            listNo: dataTable.length+1,
            benefitsName: null,
            benefitsIdCard: null,
            benefitsRate: '',
            address: null,
            providentFundRateId: providentFundRateId,
            relationShip: null
        }
        await this.setState(prevState => ({
            dataTable: [...prevState.dataTable, rows],
        }), async () => {
            let lengthData = dataTable.length+1;
            await this.setState({
                dataTalbeLengthDocument: lengthData
            })
        })
    }

    createFundBenefitPerson = async (values) =>{
        const { client, location } = this.props
        const { statusForm } = this.state
        try {
            const { data, errors } = await client.mutate({
                mutation: Mutations.createFundBenefitPerson,
                variables: {
                    benefitPersons: values.benefitPersons,
                    fundDocument: values.fundDocument,
                    status: statusForm
                }
            })

            console.log('data.createFundBenefitPerson.',data.createFundBenefitPerson)

            if(data.createFundBenefitPerson.status){
                if(statusForm == 'DRAFT'){
                    alertMessage("success","บันทึกร่างสำเร็จ")
                }else if(statusForm == 'PENDING'){
                    alertMessage("success","ส่งดำเนินการสำเร็จ")
                }

                setTimeout(() => {
                    window.location.href = '/Fund/Detail'
                }, 800);
            }
        }catch (error) {
            console.log('error',error)
            // this.hideModalConfirm()
        }
    }

    updateFundBenefitPerson = async (values) =>{
        const { client, location } = this.props
        const { statusForm, deletedFundDocumentId, deletedFundBenefitPersonId, fundRequestId, deletedFileId} = this.state
        try {
            const { data, errors } = await client.mutate({
                mutation: Mutations.updateFundBenefitPerson,
                variables: {
                    fundRequestId,
                    benefitPersons: values.benefitPersons,
                    fundDocument: values.fundDocument,
                    deletedFundDocumentId,
                    deletedFundBenefitPersonId,
                    status: statusForm,
                    deletedFileId
                }
            })

            if(data.updateFundBenefitPerson.status){
                if(statusForm == 'DRAFT'){
                    alertMessage("success","บันทึกร่างสำเร็จ")
                }else if(statusForm == 'PENDING'){
                    alertMessage("success","ส่งดำเนินการสำเร็จ")
                }else if(statusForm == 'CANCEL'){
                    alertMessage("success","ทำการยกเลิกข้อมูลผู้รับผลประโยชน์เรียบร้อย")
                }

                setTimeout(() => {
                    window.location.href = '/Fund/Detail'
                }, 800);
                await this.hideModalConfirm()
            }
        }catch (error) {
            console.log('error',error)
            // this.hideModalConfirm()
        }
    }

    createFundBenefitPersonFormPDF = async (values) =>{
        const { client, location } = this.props
        // console.log('sdfasfa', values)
        try {
            const { data, errors } = await client.mutate({
                mutation: Mutations.createFundBenefitPersonFormPDF,
                variables: {
                    benefitPersons: values,
                }
            })

            if(data.createFundBenefitPersonFormPDF.linkPDF){
                window.open(data.createFundBenefitPersonFormPDF.linkPDF, "download")
            }
        }catch (error) {
            console.log('error',error)
            // this.hideModalConfirm()
        }
    }

    checkSendValueBenefitPersonFormPDF = async () =>{
        const { client,location ,match } = this.props
        const { configDataProvPercentage, statusForm, dataTable, dataTalbeUploadsDocument, deletedFundDocumentId, deletedFundBenefitPersonId } = this.state

        let dataBenefitPersons = []
        let checkDataTableVidate = false

        if(dataTable.length > 0){
            dataTable.map((valuesPerson , keyValuesPerson) =>{
                if(!valuesPerson.benefitsName){
                    checkDataTableVidate = true
                }else if(!valuesPerson.benefitsIdCard){
                    checkDataTableVidate = true
                }else if(!valuesPerson.benefitsRate){
                    checkDataTableVidate = true
                }
            });

            if(checkDataTableVidate){
                alertMessage('error', 'กรุณาระบุข้อมูลผู้รับผลประโยชน์ให้ครบถ้วน')
            }else{
                const sum = (dataTable).reduce((accumulator, object) => {
                    return accumulator + parseFloat(object.benefitsRate);
                }, 0);
                var valueArr = (dataTable).map((item) => { return item.benefitsName.replace(/ /g, "") });
                
                var isDuplicate = valueArr.some((item, idx) => {
                    return valueArr.indexOf(item) != idx
                });
                
                var valueArrIdCard = (dataTable).map((item) => { return item.benefitsIdCard.replace(/ /g, "") });
                
                var isDuplicateIdCard = valueArrIdCard.some((item, idx) => {
                    return valueArrIdCard.indexOf(item) != idx
                });

                var valueArrRelationShip = (dataTable).map((item) => { 
                    return item.relationShip == 'บิดา' || item.relationShip == 'มารดา' || !item.relationShip ? item.relationShip : '' 
                });
        
                var isRelationShip = valueArrRelationShip.some((item, idx) => {
                    if(item){
                        return valueArrRelationShip.indexOf(item) != idx
                    }
                });

                if (sum !== 100) {
                    alertMessage('error', 'เปอร์เซ็นต์ที่ได้รับรวมกันต้อง 100%')
                }else if (isDuplicate) {
                    alertMessage('error', 'ไม่สามารถระบุชื่อผู้รับผลประโยชน์ซ้ำได้')
                }else if(isDuplicateIdCard){
                    alertMessage('error', 'ไม่สามารถระบุเลขที่บัตรประชาชนซ้ำได้')
                }else if(isRelationShip){
                    alertMessage('error', 'ไม่สามารถระบุความสัมพันธ์บิดา, มารดาซ้ำได้')
                } else {
                    dataTable.map((valuesPerson , keyValuesPerson) =>{
                        valuesPerson.listNo = keyValuesPerson+1
                        if(!valuesPerson.fundBenefitPersonId){
                            delete valuesPerson.__typename
                            dataBenefitPersons.push(valuesPerson)
                        }else{
                            delete valuesPerson.__typename
                            dataBenefitPersons.push(valuesPerson)
                        }
                    })

                    await this.createFundBenefitPersonFormPDF(dataBenefitPersons)
                }
            }
            
        }else{
            alertMessage('error', 'กรุณาเพิ่มผู้รับผลประโยชน์อย่างน้อย 1 คน')
            // alertMessage('error', dataTable.length)
        }
       
    }

    checkFormValue = async(values) =>{
        const { client,location ,match } = this.props
        const { configDataProvPercentage, statusForm, dataTable, dataTalbeUploadsDocument, deletedFundDocumentId, deletedFundBenefitPersonId } = this.state
        let ModalConfirmFormTitle = ''
        let checkModal = false
        let attachFiles = []
        let dataAttachFiles = []
        let checkModalAttachFiles = false
        let dataBenefitPersons = []
        let checkSelectAttacFileDocType = false
        
        const sum = (dataTable).reduce((accumulator, object) => {
            return accumulator + parseFloat(object.benefitsRate);
        }, 0);
        var valueArr = (dataTable).map((item) => { return item.benefitsName.replace(/ /g, "") });
        
        var isDuplicate = valueArr.some((item, idx) => {
            return valueArr.indexOf(item) != idx
        });
        
        var valueArrIdCard = (dataTable).map((item) => { return item.benefitsIdCard.replace(/ /g, "") });
        
        var isDuplicateIdCard = valueArrIdCard.some((item, idx) => {
            return valueArrIdCard.indexOf(item) != idx
        });

        var valueArrRelationShip = (dataTable).map((item) => { 
            return item.relationShip == 'บิดา' || item.relationShip == 'มารดา' ? item.relationShip : '' 
        });


        var isRelationShip = valueArrRelationShip.some((item, idx) => {
            if(item){
                return valueArrRelationShip.indexOf(item) != idx
            }
        });

        if (sum !== 100) {
            alertMessage('error', 'เปอร์เซ็นต์ที่ได้รับรวมกันต้อง 100%')
        }else if (isDuplicate) {
            alertMessage('error', 'ไม่สามารถระบุชื่อผู้รับผลประโยชน์ซ้ำได้')
        }else if(isDuplicateIdCard){
            alertMessage('error', 'ไม่สามารถระบุเลขที่บัตรประชาชนซ้ำได้')
        }else if(isRelationShip){
            alertMessage('error', 'ไม่สามารถระบุความสัมพันธ์บิดา, มารดาซ้ำได้')
        }else{
            if(statusForm == 'DRAFT'){
                ModalConfirmFormTitle = 'ยืนยันการบันทึกร่าง'
            }else if(statusForm == 'PENDING'){
                ModalConfirmFormTitle = 'ยืนยันการเปลี่ยนแปลงข้อมูลผู้รับผลประโยชน์'
            }else if(statusForm == 'CANCEL'){
                ModalConfirmFormTitle = 'ยืนยันการยกเลิกข้อมูลผู้รับผลประโยชน์'
            }

            let checkDocumentType = dataTalbeUploadsDocument.filter(valuesData => valuesData.documentType == 'ใบกองทุนสำรองเลี้ยงชีพ');

            // if(checkDocumentType.length !== 0){
                dataTalbeUploadsDocument.filter(valuesData => valuesData.fundDocumentId == null).map(dataUploadsDocument => {
                    delete dataUploadsDocument.fundDocumentId
                    dataAttachFiles.push(dataUploadsDocument)
                })

                // if(dataAttachFiles.length !== 0){
                    dataTalbeUploadsDocument.map((valuesFile , keyValuesFile) =>{
                        // console.log('valuesFile',valuesFile)
                        if(!valuesFile.fundDocumentId){
                            if(valuesFile.documentType){
                                if(valuesFile.file.length == 0){
                                    document.getElementById('showTextUplodasDoc'+keyValuesFile).classList.add("color-red")
                                    checkModalAttachFiles = true
                                }
                            }
    
                            if(valuesFile.documentType || valuesFile.description || valuesFile.file.length !== 0){
                                let dataArray = {
                                    documentType: valuesFile.documentType ? valuesFile.documentType : '',
                                    description: valuesFile.description ? valuesFile.description : '',
                                    file: valuesFile.file,
                                }
                                attachFiles.push(dataArray)
                            }
                        }else{
                            if(valuesFile.file.length == 0){
                                document.getElementById('showTextUplodasDoc'+keyValuesFile).classList.add("color-red")
                                checkModalAttachFiles = true
                            }else{
                                let dataArray = {
                                    fundDocumentId: valuesFile.fundDocumentId,
                                    documentType: valuesFile.documentType ? valuesFile.documentType : '',
                                    description: valuesFile.description ? valuesFile.description : '',
                                    file: valuesFile.file.filter((values) => !values.fileId),
                                }
                                attachFiles.push(dataArray)
                            }
                        }
                    })
                // }

                if(checkModalAttachFiles){
                    Modal.error({
                        title: 'กรุณาอัปโหลดไฟล์เอกสารแนบ',
                        className:'custom-modal-error',
                        okText:"ตกลง"
                    });
                    // await this.hideModalConfirm()
                }else{
                    // dataTable.Table.map
                    dataTable.map((valuesPerson , keyValuesPerson) =>{
                        valuesPerson.listNo = keyValuesPerson+1
                        if(!valuesPerson.fundBenefitPersonId){
                            delete valuesPerson.__typename
                            dataBenefitPersons.push(valuesPerson)
                        }else{
                            delete valuesPerson.__typename
                            dataBenefitPersons.push(valuesPerson)
                        }
                    })
                    // dataBenefitPersons
                    values.benefitPersons = dataBenefitPersons
                    values.fundDocument = attachFiles
                    values.deletedFundDocumentId = deletedFundDocumentId
                    values.deletedFundBenefitPersonId = deletedFundBenefitPersonId
                    let ModalSubmitToSend = this.createFundBenefitPerson
                    // console.log('123123', match.url.split('/')[3])
                    if(match.url.split('/')[3]){
                        ModalSubmitToSend = this.updateFundBenefitPerson
                        // await this.fetchFundChangeBenefitPersonDetail()
                    }
                    
                    await this.setState({
                        ModalConfirmFormTitle,
                        ModalConfirmFormShowModal:true,
                        ModalConfirmFormBtnOk:"ตกลง",
                        ModalConfirmFormBtnCancel:'ยกเลิก',
                        ModalConfirmFormValue:values,
                        ModalConfirmFormStatus: null,
                        ModalConfirmFormMessage: null,
                        ModalFormTextArea: null,
                        ModalFormTextAreaRequie: null,
                        ModalSubmitToSend
                    })
                } 
            // }else{
            //     Modal.error({
            //         title: 'กรุณาอัปโหลดไฟล์เอกสารใบกองทุนสำรองเลี้ยงชีพ',
            //         className:'custom-modal-error',
            //         okText:"ตกลง"
            //     });
            // }
        }
    }

    showModalConfirm = async (e) =>{
        const { configDataProvPercentage, statusForm, dataTable, dataTalbeUploadsDocument } = this.state
        // console.log('showModalConfirm')
		e.preventDefault()
		this.props.form.validateFields( async(err, values) => {
            if (!err) {
                if(dataTable.length !== 0){
                    await this.checkFormValue(values)
                }else{
                    Modal.error({
                        title: 'กรุณาระบุผู้รับผลประโยชน์อย่างน้อย 1 รายการ',
                        className:'custom-modal-error',
                        okText:"ตกลง"
                    });
                }
            }
		});
	}

    hideModalConfirm = async () =>{
        await this.setState({
            ModalConfirmFormTitle:null,
            ModalConfirmFormSubTitle:null,
            ModalConfirmFormShowModal:false,
            ModalConfirmFormBtnOk:null,
            ModalConfirmFormBtnCancel:null,
            ModalConfirmFormValue:null,
            ModalConfirmFormStatus:null,
            ModalConfirmFormMessage:null,
            preLoadOnsubmit: false
        })
    }

    showDataInputUploadsDocument = async () =>{
        const { dataTalbeUploadsDocument, reqAttachDayStatus } = this.state
        const rows = {
            fundDocumentId: null,
            documentType: null,
            statusFile: false,
            description: null,
            file: [],
        }
        await this.setState(prevState => ({
            dataTalbeUploadsDocument: [...prevState.dataTalbeUploadsDocument, rows],
        }), async () => {
            let lengthData = dataTalbeUploadsDocument.length+1;
            await this.setState({
                dataTalbeLengthDocument: lengthData
            })
        })
    }

    fetchAllProvidentFundDetail = async ()=>{
        const { client, location, match } = this.props

		try {
			const { data, errors } = await client.query({
				query: Queries.fetchAllProvidentFundDetail,
			})

			if(data.fetchAllProvidentFundDetail){
                let daTable = [
                        {
                            listNo:1,
                            benefitsName:null,
                            benefitsIdCard:null,
                            benefitsRate:null,
                            address:null,
                            providentFundRateId: data.fetchAllProvidentFundDetail.employeeFundPolicy.providentFundRateId,
                        },
                    ]    
				
                if(!match.url.split('/')[3]){
                    await this.setState({
                        dataTable: data.fetchAllProvidentFundDetail.providentFundBenefitsPerson ? data.fetchAllProvidentFundDetail.providentFundBenefitsPerson.benefitsPerson : daTable,
                        loadTable: false,
                    })
                }
                await this.setState({
					providentFundRateId: data.fetchAllProvidentFundDetail.employeeFundPolicy.providentFundRateId,
                    loadTable: false,
				})

			}else{
				await this.setState({
					showDataPreLoads: false
				})
			}
		} catch (e) {
            // console.log('123123')
			// message.error('Something went wrong. Please try again')
		}
    }

    fetchFundChangeBenefitPersonDetail = async () =>{
        const { client, location, match } = this.props
        // console.log('1111',match.url.split('/')[3])
		try {
			const { data, errors } = await client.query({
                query: Queries.fetchFundChangeBenefitPersonDetail,
                variables: {
                    fundRequestId:match.url.split('/')[3],
                }
            })

            if(data.fetchFundChangeBenefitPersonDetail){
                data.fetchFundChangeBenefitPersonDetail.benefitPersons.map((values, key)=>{
                    data.fetchFundChangeBenefitPersonDetail.benefitPersons[key] = data.fetchFundChangeBenefitPersonDetail.benefitPersons[key]
                })
    
                if(data.fetchFundChangeBenefitPersonDetail.fundDocument.length !== 0){
                    data.fetchFundChangeBenefitPersonDetail.fundDocument.map((values, key)=>{
                        data.fetchFundChangeBenefitPersonDetail.fundDocument[key].file = data.fetchFundChangeBenefitPersonDetail.fundDocument[key].fileData
                    })
                }

                await this.setState({
                    dataTable: data.fetchFundChangeBenefitPersonDetail.benefitPersons,
                    dataTalbeUploadsDocument: data.fetchFundChangeBenefitPersonDetail.fundDocument,
                    loadTable: false,
                    fundRequestId:match.url.split('/')[3],
                    statusInput: data.fetchFundChangeBenefitPersonDetail.status == 'DRAFT' ? false : true,
                    statusFormBtn: data.fetchFundChangeBenefitPersonDetail.status,
                    statusCanEdit: data.fetchFundChangeBenefitPersonDetail.status == 'DRAFT' ? "canEdit" : 'No',
                    detailForm: data.fetchFundChangeBenefitPersonDetail
                })
            }
		} catch (e) {
            console.log('xxx1')
			// message.error('Something went wrong. Please try again')
		}
    }

    testSend = async () =>{
        var axios = require('axios');
        var data = JSON.stringify({
            "identitycard": "3310400494592",
            "orgCode": "07",
            "isReqByEmp": true,
            "leaveTypeId": "1",
            "reqLeaveDate": "2022-01-05"
        });

        // var config = {
        // method: 'post',
        // url: 'https://hrmi-api-uat.redcross.or.th/api/Leave/GetLeaveDay',
        // headers: { 
        //     'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaWQiOiIxIiwibmFtZWlkIjoiMDAyIiwibmFtZSI6ImkzdnRyYyIsInR5cCI6InJlcXVlc3RBcGkiLCJqdGkiOiI5NTI2MjliMy0yYWZjLTQ1N2YtYjNlZC1hZDUyMTM3OGE2YmMiLCJleHAiOjE2NTM0NjUyODQsImlzcyI6IlByb3NvZnRIUk1JQGdtYWlsLmNvbSIsImF1ZCI6IlByb3NvZnRIUk1JQGdtYWlsLmNvbSJ9.1-k-G8SjaPCX0SCpevdVRspKgPIjKL-nYViWt4duMY4', 
        //     'Content-Type': 'application/json'
        // },
        // data : data
        // };

        // axios(config)
        // .then(function (response) {
        //     console.log(JSON.stringify(response.data));
        // })
        // .catch(function (error) {
        //     console.log(error);
        // });
    }


    dropdownRelationShipLabel = async () =>{
        const { client, location, match } = this.props
        // console.log('1111',match.url.split('/')[3])
		try {
			const { data, errors } = await client.query({
                query: Queries.dropdownRelationShipLabel,
            })


            console.log('asdfasfd',data.dropdownRelationShipLabel);
            if(data.dropdownRelationShipLabel){
                await this.setState({
                    dropdownRelationShipLabel: data.dropdownRelationShipLabel
                })
            }
		} catch (e) {
            console.log('xxx1')
            await this.setState({
                loadingFullpage: false
            })
			// message.error('Something went wrong. Please try again')
		}
    }



    async componentDidMount(){
        const { client,location ,match } = this.props
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
          });
        await this.dropdownRelationShipLabel()
        await this.fetchAllProvidentFundDetail()
        // await this.testSend()
        if(match.url.split('/')[3]){
            await this.setState({
                loadTable: true
            })
            await this.fetchFundChangeBenefitPersonDetail()
        }else{
            await this.setState({
                statusFormBtn: "DRAFT",
                statusInput: false
            })
        }
    }

	render() {
		const { modalCondition2, hideModalCondition2, match } = this.props
		const { getFieldDecorator } = this.props.form;
		const { 
                dataTable, 
                columns, 
                nameImage,
                ModalConfirmFormTitle,
                ModalConfirmFormSubTitle,
                ModalConfirmFormShowModal,
                ModalConfirmFormBtnOk,
                ModalConfirmFormBtnCancel,
                ModalConfirmFormValue,
                ModalFormTextArea,
                ModalFormTextAreaRequie,
                showDataPreLoads,
                columnsDocument,
                dataTalbeUploadsDocument,
                detailForm,
                ModalshowAllImageTitle,
                ModalshowAllImageVisible,
                ModalshowAllImageData,
                ModalshowAllImageArrayId,
                ModalshowAllImageDatabase,
                ModalSubmitToSend,
                statusCanEdit,
                providentFundRateId,
                deletedFundDocumentId,
                deletedFundBenefitPersonId,
                loadTable,
                statusInput,
                statusFormBtn,
                providentFundBenefitsPersonIsActiveBtn,
            } = this.state

            console.log('statusFormBtn',statusFormBtn)
		return (
			<>
                <ModalshowAllImage
                    title={ModalshowAllImageTitle} 
                    showModal={ModalshowAllImageVisible}
                    data={ModalshowAllImageData}
                    hideModal={ this.ModalshowAllImageHide }
                    dataArrayId={ ModalshowAllImageArrayId }
                    destroyArrayDataImages = { this.destroyArrayDataImages }
                    imageDatabase = {ModalshowAllImageDatabase}
                    statusForm={statusCanEdit}
                />

                <ModalConfirmForm 
					title={ModalConfirmFormTitle} 
					subtitle={ModalConfirmFormSubTitle}
					showModal={ModalConfirmFormShowModal} 
					btnOk={ModalConfirmFormBtnOk} 
					btnCancel={ModalConfirmFormBtnCancel}  
					submitToSend={ ModalSubmitToSend }
					hideModal={ this.hideModalConfirm }
					valueConfirm = { ModalConfirmFormValue }
					ModalFormTextArea = {ModalFormTextArea}
					ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
				/>
                
                <Container match={match}>
                    <div className="card-container" id="page-profile">
                        <Spin spinning={showDataPreLoads}>
                            <div className="px-5 py-1 card-bg-green">
                                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mx-0" style={{ borderRadius:"0" }}>
                                    <Form {...formItemLayout} ref={this.formRef}  onSubmit={this.showModalConfirm}>
                                        <Row gutter={16} type="flex" justify="left" align="top" className="">
                                            {
                                                detailForm &&
                                                    <Col md={24} className="mb-3">
                                                        <span className="color-gray">เลขที่เอกสาร</span>
                                                        <Title className="color-blue-green mt-1" level={4} style={{ position:"relative" }}>
                                                            { detailForm.fundRequestNo }
                                                            <span className={'ml-4 color-gray text-detail-status '+checkStatusSessionHistory(detailForm.status, true)}>
                                                                { checkStatusSessionHistory(detailForm.status) }
                                                            </span>
                                                        </Title>
                                                    </Col>
                                            }
                                           
                                            <Col xs={24} md={24} align={"right"}>
                                                <Table
                                                    locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                                    columns={columns}
                                                    dataSource={dataTable}
                                                    pagination={false}
                                                    className="mb-3"
                                                    bordered
                                                    loading={loadTable}
                                                    // rowCount={dataTalbeUploadsDocument.length}
                                                    // pagination={{ pageSize: dataTalbeUploadsDocument.length }}
                                                />
                                            </Col>
                                            <Col xs={24} md={12} align={"left"}>
                                                {
                                                   (statusFormBtn == 'DRAFT' || statusFormBtn == 'PENDING') &&
                                                    <Button 
                                                        style={{ display:"inline-block" }}
                                                        type="primary"
                                                        // htmlType="submit"
                                                        className="mt-1 mr-2 px-4 btn-color-default btn-clear color-white"
                                                        onClick={async () => this.checkSendValueBenefitPersonFormPDF() }
                                                    >
                                                        พิมพ์ใบกองทุนสำรองเลี้ยงชีพ
                                                    </Button>
                                                }
                                            </Col>
                                            <Col xs={24} md={12} align={"right"}>
                                            {
                                                    statusFormBtn == 'DRAFT' &&
                                                        <Button 
                                                            style={{ display:"inline-block" }}
                                                            type="primary btn-color-default btn-clear color-white" 
                                                            className="mt-1 mr-2 px-4"
                                                            onClick={ () => this.showDataInput() }
                                                            disabled={ dataTable.length == 4 ? true : false }
                                                        >
                                                            เพิ่มผู้รับผลประโยชน์ +
                                                        </Button>
                                                }
                                            </Col>
                                            <Col md={24} className="mt-4">
                                                <strong className="color-red">
                                                    เงื่อนไขการได้รับผลประโยชน์ *
                                                </strong>
                                                <ol>
                                                    <li className="mb-0">
                                                        กำหนดส่วนแบ่งผู้รับผลประโยชน์ ให้ได้ไม่เกิน 4 คน และรวมกันได้ 100%
                                                    </li>
                                                    <li className="">
                                                        พิมพ์แบบหนังสือแจ้งเปลี่ยนแปลงผู้รับผลประโยชน์ และลงลายมือชื่อด้วยปากกาน้ำเงินเท่านั้น และแนบสำเนาบัตรประชาชนของผู้รับผลประโยชน์<br></br> 
                                                        (ปิดหมู่เลือดและศาสนา หรือใช้ปากกาดำป้ายทับตรงหมู่เลือดและศาสนา)
                                                    </li>
                                                    <li>
                                                        ส่งกลับมาที่สำนักงานบริหารทรัพยากรบุคคล สภากาชาดไทย<br></br>
                                                        เลขที่ 1871 อาคารเฉลิมบุรณะนนท์ ชั้น 3<br></br>
                                                        ถนนพระราม 4 แขวงปทุมวัน<br></br>
                                                        เขตปทุมวัน กรุงเทพฯ 10330 <br></br>
                                                        (งานกองทุนสำรองเลี้ยงชีพ สภากาชาดไทย)
                                                    </li>
                                                    <li>
                                                        สำนักงาน​บริหาร​ทรัพยากร​บุคคล​ เสนอกรรมการฯ​ เพื่อลงนาม
                                                    </li>
                                                </ol>
                                                
                                            </Col>
                                        </Row>

                                        <Row className="my-4">
                                            <Col>
                                                <hr></hr>
                                            </Col>
                                        </Row>

                                        <Row className="mt-4">
                                            <Col xs={24} md={24} className="mb-3">
                                                <strong className="color-red">
                                                    เอกสารแนบ
                                                </strong>
                                            </Col>
                                            <Col xs={24} md={24} align={"right"}>
                                                <Table
                                                    locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                                    columns={columnsDocument}
                                                    dataSource={dataTalbeUploadsDocument}
                                                    pagination={false}
                                                    className="mb-3"
                                                    bordered
                                                    scroll={{ x:"max-content"}}
                                                    // rowCount={dataTalbeUploadsDocument.length}
                                                    // pagination={{ pageSize: dataTalbeUploadsDocument.length }}
                                                />
                                                
                                                {/* {
                                                    (detailForm.status == 'MOREINFO' || detailForm.status == 'DRAFT' ) && */}
                                                    {
                                                        !statusInput &&
                                                        <Button 
                                                            style={{ display:"inline-block" }}
                                                            type="primary btn-color-default btn-clear color-white" 
                                                            className="mt-1 mr-2"
                                                            onClick={ () => this.showDataInputUploadsDocument() }
                                                            // disabled={true}
                                                        >
                                                            เพิ่มเอกสาร
                                                        </Button>
                                                    }
                                            </Col>
                                        </Row>

                                        {
                                            detailForm &&
                                                detailForm.status == 'REJECT' &&
                                                <Row className="mt-3">
                                                    <Col xs={24} md={24}>
                                                        <label>
                                                            หมายเหตุการไม่อนุมัติเอกสาร : <span className="ml-1">{ detailForm.remark }</span>
                                                        </label>
                                                    </Col>
                                                </Row>
                                        }

                                        <Row className="mt-5">
                                            <Col style={{ textAlign:"center"}}>
                                                <Link
                                                    to={{
                                                        pathname: '/Fund/Detail',
                                                    }}
                                                >
                                                    <Button className="btn-white-red" onClick={hideModalCondition2}>
                                                        ย้อนกลับ
                                                    </Button>
                                                </Link>

                                                {
                                                    statusFormBtn == 'PENDING' &&
                                                    <Button 
                                                        className="mx-2 btn-white-red" 
                                                        onClick={async () => await this.setState({
                                                            statusForm: "CANCEL"
                                                        })}
                                                        type="primary" 
                                                        htmlType="submit" 
                                                    >
                                                        ยกเลิกเอกสาร
                                                    </Button>
                                                }
                                                
                                                {
                                                    statusFormBtn == 'DRAFT' &&
                                                    <Button 
                                                        className="mx-2 btn-white-red" 
                                                        onClick={async () => await this.setState({
                                                            statusForm: "DRAFT"
                                                        })}
                                                        type="primary" 
                                                        htmlType="submit" 
                                                    >
                                                        บันทึกร่าง
                                                    </Button>
                                                }
                                                
                                                {
                                                    statusFormBtn == 'DRAFT' &&
                                                        <Button 
                                                            type="primary" 
                                                            htmlType="submit" 
                                                            className="color-white"
                                                            onClick={async () => await this.setState({
                                                                statusForm: "PENDING"
                                                            })}
                                                        >
                                                            ส่งดำเนินการ
                                                        </Button>
                                                }
                                            </Col>
                                        </Row>
                                    </Form>
                                </Row>
                            </div>
                        </Spin>
                    </div>
                </Container>
			</>
		)
	}
}

benefitsPerson.defaultProps = {
	autoFocus: false
}

benefitsPerson.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedbenefitsPerson = Form.create()(benefitsPerson)

export default withApollo(WrappedbenefitsPerson)